export const formatToMMDDYYYY = (dateStr) => {
  if (!dateStr) return "";
  const parts = dateStr.split("-");
  if (parts.length !== 3) return "";
  const [year, month, day] = parts;
  return `${month.padStart(2, "0")}/${day.padStart(2, "0")}/${year}`;
};
